import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mtop-05" }
const _hoisted_2 = { class: "mtop-10" }
const _hoisted_3 = { class: "mtop-20" }
const _hoisted_4 = { class: "row mtop-02" }
const _hoisted_5 = { class: "mtop-20 row gap-15" }

import { ref, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import patientapi from '@/api/patientapi';
import Select from 'primevue/select';
import InputText from 'primevue/inputtext';
import { InvoiceResponse } from '@/apiGenerate/medserver';


export default /*@__PURE__*/_defineComponent({
  __name: 'luPidContest',
  props: {
  invoice: {
    type: Object as PropType<InvoiceResponse> ,
    required: true,
  },
  simulationAnomalies: {
    type: Array,
    required: false,
  },
  eConnectorAwaiting: {
    type: Boolean,
    required: false
  }
},
  emits: ['contestPid'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit
const {t} = useI18n();

const contestationReasonRef = ref(null)
const contestationReason = ref('')
const luBillEtransferData = ref(props.invoice.patientDocument.luBillEtransferData)

const selectedAnomaly = ref();
const selectedContestationType = ref();
const contestationTypeList = [
  {code: '1', description: 'accounting.econnector.pidContestation.type.interpretation'},
  {code: '2', description: 'accounting.econnector.pidContestation.type.programatic'}
]

async function update() {
  if (!selectedAnomaly.value || !selectedContestationType.value || !contestationReason.value) return;
  await updateContestationReason();
  emits('contestPid');
}

async function updateContestationReason() {
  const invoiceId = props.invoice.id
  const oldReason = luBillEtransferData.value.contestationReason
  const newReason = contestationReason.value
  //if (oldReason === newReason) return
  luBillEtransferData.value.contestationReason = newReason;
  luBillEtransferData.value.constestationCode = selectedContestationType.value.code;
  luBillEtransferData.value.contestationId = selectedAnomaly.value.id;
  await patientapi.updateContestationReason(invoiceId.toString(), newReason, selectedAnomaly.value.id, selectedContestationType.value.code)
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_button_group = _resolveComponent("button-group")!

  return (_openBlock(), _createElementBlock("div", {
    class: "pad-m rnd-m",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('accounting.econnector.pidContestation.selectAnomaly')), 1)
    ]),
    _createVNode(_unref(Select), {
      modelValue: selectedAnomaly.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAnomaly).value = $event)),
      invalid: !selectedAnomaly.value,
      options: props.simulationAnomalies,
      optionLabel: "description",
      placeholder: "Selectionner une anomalie",
      class: "w-full md:w-56"
    }, null, 8, ["modelValue", "invalid", "options"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('accounting.econnector.pidContestation.selectType')), 1)
    ]),
    _createVNode(_unref(Select), {
      modelValue: selectedContestationType.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedContestationType).value = $event)),
      invalid: !selectedContestationType.value,
      options: contestationTypeList,
      optionLabel: "description",
      placeholder: "Selectionner le type de contestation",
      class: "w-full md:w-56"
    }, _createSlots({
      option: _withCtx((slotProps) => [
        _createTextVNode(_toDisplayString(_unref(t)(`${slotProps.option.description}`)), 1)
      ]),
      _: 2
    }, [
      (selectedContestationType.value)
        ? {
            name: "value",
            fn: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_unref(t)(`${slotProps.value.description}`)), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "invalid"]),
    _createVNode(_component_text_item, {
      txt: "Motif",
      class: "mtop-10"
    }),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(InputText), {
        type: "text",
        size: "small",
        modelValue: contestationReason.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contestationReason).value = $event)),
        invalid: !contestationReason.value,
        class: "w-full"
      }, null, 8, ["modelValue", "invalid"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_button_group, {
        styles: "border-h pad-s",
        disabled: __props.eConnectorAwaiting,
        class: "psides-10",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (update()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_text_item, {
            txt: "Envoyer contestation",
            styles: "font-mBold"
          })
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})